import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Flex,
  Form,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
} from 'antd';
import IntlMessage from '../../components/IntlMessage';
import { Line } from '@ant-design/charts';
import { SearchOutlined } from '@ant-design/icons';
import PageTitle from '../../components/PageTitle';
import useTime from '../../hooks/useTime';
import dayjs from 'dayjs';
import {
  formatCurrency,
  formatNumber,
  formatShortCurrency,
  formatShortNumber,
} from '../../helpers/helpers';
import destinationsApi from '../../api/destinations';
import _ from 'lodash';
import routesApi from '../../api/route';
import { isMobile } from 'react-device-detect';
import reportApi from '../../api/report';
import { formatCurrencyCustom } from '../../utils/helpers';

export const chartSalesType = {
  TOTAL: 'total',
  YOBUMA: 'yobuma',
  CASHIER: 'caissier',
  BAGAGES: 'bagages',
};
const { Text } = Typography;
const fs_16 = {
  fontSize: '16px',
};
const Statistics = (props) => {
  const [form] = Form.useForm();
  const [filter, setFilter] = useState({
    keyword: '',
    date_mode: 'date',
    from_date: dayjs().subtract(7, 'day').endOf('day').toISOString(),
    to_date: dayjs().startOf('day').toISOString(),
    filter_name: [],
    filter_value: [],
  });
  const [dataChart, setDataChart] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [dataTable_first, setDataTable_first] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState({
    yobuma: 0,
    cashier: 0,
    filling_rate: 0,
    pass_cashier: 0,
    pass_yobuma: 0,
  });
  const [mode, setMode] = useState('date');
  const [modalPass, setModalPass] = useState(false);
  const [modalRoute, setModalRoute] = useState(false);
  const [search, setSearch] = useState(false);
  const [item, setItem] = useState({});
  const [condition, setCondition] = useState({});
  const { formatAsISOString } = useTime();
  const [rawDataChart, setRawDataChart] = useState([]);
  const [items, setItems] = useState([]);
  const [type, setType] = useState(null);
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);

        if (props.operator_id) {
          const index = filter.filter_name.indexOf('operator_id');

          if (index === -1) {
            // chưa tồn tại -> thêm mới
            filter.filter_name = [...filter.filter_name, 'operator_id'];
            filter.filter_value = [...filter.filter_value, props.operator_id];
          } else {
            // đã tồn tại -> update value
            filter.filter_value[index] = props.operator_id;
          }
        } else {
          // nếu không có operator_id -> xóa filter
          const index = filter.filter_name.indexOf('operator_id');
          if (index !== -1) {
            filter.filter_name.splice(index, 1);
            filter.filter_value.splice(index, 1);
          }
        }
        Promise.all([
          reportApi.getAll(filter),
          reportApi.getDesByOperator(
            props?.operator_id ? props.operator_id : '0',
          ),
          // destinationsApi.getAll(filter),
        ]).then((res) => {
          console.log('res[0]?.data', res[0]);
          if (res[0]) {
            setDataTable(res[0]?.data);
            setDataTable_first(res[0]?.data);

            const dataChart = res[0]?.data_revenue?.flatMap((item) => [
              {
                date: item.date,
                title: 'yobuma',
                total: item.yobuma,
              },
              {
                date: item.date,
                title: 'caissier',
                total: item.cashier,
              },
              {
                date: item.date,
                title: 'total',
                total: item.total,
              },
            ]);

            console.log('dataChart', dataChart);
            setDataChart(dataChart);
            setItems(dataChart);
            setRawDataChart(res[0]?.data_revenue);
            setTotal({
              yobuma: res[0]?.yobuma,
              cashier: res[0]?.cashier,
              filling_rate: Number(res[0]?.filling_rate),
              pass_cashier: res[0]?.pass_cashier,
              pass_yobuma: res[0]?.pass_yobuma,
            });
          }
          console.log('res[1]?.data', res[1]);
          if (Array.isArray(res[1])) {
            setDestinations(res[1]);
          }

          setLoading(false);
        });
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }

    fetchData();
  }, [search, props?.operator_id]);

  // useEffect(() => {
  //   async function fetchData() {
  //     try {
  //       const payload = {
  //         limit: 999,
  //         page: 1,
  //         order_by: 'title',
  //         order_dir: 'ASC',
  //       };
  //       const res = await destinationsApi.getAll(payload);
  //       setDestinations(res?.data);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   }

  //   fetchData();
  // }, []);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObject(
        filter?.filter_name,
        filter?.filter_value,
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const option = {
    data: dataChart,
    xField: 'date',
    yField: 'total',
    seriesField: 'title',
    animation: {
      appear: {
        animation: 'path-in',
        duration: 1000,
      },
    },

    shapeField: 'smooth',
    point: {
      shapeField: 'square',
      sizeField: 1,
    },
    encode: {
      x: 'date',
      y: 'total',
      color: 'title',
    },
    scale: {
      color: {
        domain: ['total', 'caissier', 'yobuma'],
        range: ['#52c41a', '#3c74ce', '#722ed1'],
      },
    },
    legend: {
      color: {
        layout: {
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        },
      },
    },
    style: {
      lineWidth: 2.5,
      // stroke: '#3c74ce',
      // strokeOpacity: 1,
    },
    axis: {
      y: {
        position: 'right',
        labelFormatter: (value) => {
          return formatShortNumber(Number(value));
        },
        gridLineWidth: 2,
        gridStroke: '#3c74ce',
        gridLineDash: [0, 0],
      },
      x: {
        labelFormatter: (value) => {
          return /^[-]?\d+$/.test(String(value).trim())
            ? `${String(Number(value)).padStart(2, '0')}:00`
            : dayjs(value, 'YYYY/MM/DD').format('DD MMM YY');
        },
        labelAutoRotate: false,
        labelAutoHide: true,
      },
    },
    interaction: {
      tooltip: {
        render: (e, { title, items }) => {
          const list = items;
          const item = items.find((item) => item.name === 'date');
          const ORDER = ['total', 'caissier', 'yobuma', 'bagages'];

          const sortedList = list
            .filter((item) => item.name !== 'date' && item.name !== 'subtotal')
            .sort((a, b) => ORDER.indexOf(a.name) - ORDER.indexOf(b.name));
          return (
            <div key={item?.value}>
              <div>
                {/^[-]?\d+$/.test(String(title).trim())
                  ? `${String(Number(title)).padStart(2, '0')}:00`
                  : dayjs(title).format('DD MMM YY')}
              </div>
              {sortedList.map((item) => {
                const { value, name, color } = item;
                console.log('item', item);
                return (
                  <div>
                    <div
                      style={{
                        margin: 0,
                        display: 'flex',
                        justifyContent: 'space-between',
                        minWidth: 150,
                      }}>
                      <div>
                        <span
                          style={{
                            display: 'inline-block',
                            width: 6,
                            height: 6,
                            borderRadius: '50%',
                            backgroundColor: color,
                            marginRight: 6,
                          }}></span>
                        <span>
                          {name === 'caissier'
                            ? 'Caissier'
                            : name === 'total'
                              ? 'Total'
                              : name === 'yobuma'
                                ? 'Yobuma'
                                : 'Bagages'}
                        </span>
                      </div>
                      <b>{formatCurrency(value)}</b>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        },
      },
    },
  };

  const changeDestination = (value, title) => {
    const filter_obj = { ...condition, [title]: value };
    let filter_name = [];
    let filter_value = [];
    for (var key in filter_obj) {
      if (filter_obj[key]) {
        filter_name.push(key);
        filter_value.push(filter_obj[key]);
      }
    }
    setFilter((filter) => {
      return {
        ...filter,
        filter_name: filter_name,
        filter_value: filter_value,
      };
    });
  };

  const onChangeMode = (value) => {
    setMode(value);
    // setFilter({
    //   mode: value,
    //   from_date: dayjs().startOf(value).toISOString(),
    //   to_date: dayjs().endOf(value).toISOString(),
    // });
    form.setFieldsValue({
      from_date: value === 'date' ? dayjs().startOf('month') : dayjs(),
      to_date: value === 'date' ? dayjs().endOf('month') : dayjs(),
    });
  };

  const onChangeType = async (value) => {
    try {
      if (type === value) {
        setType(null);
        setDataChart(items);
      } else {
        setType(value);
        const data = items.filter((item) => item.title === value);
        setDataChart(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onSearch = () => {
    form.validateFields().then((values) => {
      console.log('values', values);
      setFilter((item) => {
        return {
          ...item,
          // keyword: values?.keyword,
          date_mode: mode,
          from_date:
            mode === 'date'
              ? values.from_date?.toISOString()
              : values.from_date?.startOf(mode).toISOString(),
          to_date:
            mode === 'date'
              ? values.to_date?.toISOString()
              : values.from_date?.endOf(mode)?.toISOString(),
          from: values?.from_dest,
          // filter_name: ['from', 'to'],
          // filter_value: [values?.from, values?.to],
        };
      });

      setSearch((e) => !e);
    });
  };

  const columns = [
    {
      key: 'routes',
      title: <IntlMessage id="global.routes" />,
      width: isMobile ? 170 : 300,
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            <Text>
              {record?.start_location?.title} ~ {record?.end_location?.title}
            </Text>
          </>
        );
      },
    },
    {
      key: 'code',
      title: <IntlMessage id="global.code" />,
      render: (text, record) => {
        return record?.sku;
      },
    },
    // {
    //   key: 'total_pass',
    //   title: '#',
    //   render: (text, record) => {
    //     return formatNumber(record?.pass_cashier + record?.pass_yobuma);
    //   },
    // },
    {
      key: 'total',
      title: <IntlMessage id="global.total" />,
      render: (text, record) => {
        return formatCurrencyCustom(
          record?.cashier + record?.yobuma,
          JSON.parse(props?.operator?.params || '{}'),
        );
      },
    },
    // {
    //   key: 'passenger_yobuma',
    //   title: '#yobuma',
    //   render: (text, record) => {
    //     return formatNumber(record?.pass_yobuma);
    //   },
    // },

    {
      key: 'yobuma',
      title: <IntlMessage id="global.yobuma" />,
      render: (text, record) => {
        return formatCurrencyCustom(
          record?.yobuma,
          JSON.parse(props?.operator?.params || '{}'),
        );
      },
    },
    // {
    //   key: 'passenger_cashier',
    //   title: '#cashier',
    //   render: (text, record) => {
    //     return formatNumber(record?.pass_cashier);
    //   },
    // },
    {
      key: 'cashier',
      title: <IntlMessage id="global.cashier" />,
      render: (text, record) => {
        return formatCurrencyCustom(
          record?.cashier,
          JSON.parse(props?.operator?.params || '{}'),
        );
      },
    },
    {
      key: 'filling_rate',
      title: <IntlMessage id="global.filling_rate" />,
      render: (text, record) => {
        return `${Number(record?.filling_rate).toFixed(2)} %`;
      },
    },
  ];

  return (
    <Space style={{ width: '100%' }} direction="vertical" size={6}>
      <>
        <Row>
          <Col>
            <Form layout="inline" form={form} onFinish={onSearch}>
              {/* <Form.Item name={'keyword'}>
            <Input placeholder="Search..." />
          </Form.Item> */}
              <Form.Item name={'from'}>
                <Select
                  showSearch
                  placeholder={<IntlMessage id="global.depart" />}
                  allowClear={true}
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    return (
                      option?.children
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  }}
                  onChange={(value) => changeDestination(value, 'from')}>
                  {destinations?.map((item) => {
                    return (
                      <Select.Option key={item.id} value={item.id}>
                        {item?.title}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item name={'to'}>
                <Select
                  showSearch
                  placeholder={<IntlMessage id="global.arrivee" />}
                  allowClear={true}
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    return (
                      option?.children
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  }}
                  onChange={(value) => changeDestination(value, 'to')}>
                  {destinations?.map((item) => {
                    return (
                      <Select.Option key={item.id} value={item.id}>
                        {item?.title}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Row justify={'start'}>
                {/* <Col>
                             <Radio.Group
                               name="date_type"
                               onChange={(e) =>
                                 onFilter(e.target.value, e.target.name, '')
                               }
                               defaultValue={dataDateType[0].value}>
                               <Flex vertical>
                                 {dataDateType?.map((item, index) => {
                                   return (
                                     <Radio key={index} value={item?.value}>
                                       {item?.label}
                                     </Radio>
                                   );
                                 })}
                               </Flex>
                             </Radio.Group>
                           </Col> */}
                <Col>
                  <Form.Item
                    name={'mode'}
                    initialValue={'date'}
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id="global.requiredfeild" />,
                      },
                    ]}>
                    <Select
                      placeholder="Select mode"
                      onSelect={onChangeMode}
                      options={[
                        {
                          value: 'date',
                          label: <IntlMessage id="global.date" />,
                        },
                        {
                          value: 'month',
                          label: <IntlMessage id="global.month" />,
                        },
                        {
                          value: 'day',
                          label: <IntlMessage id="global.day" />,
                        },
                      ]}></Select>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="from_date"
                    // initialValue={dayjs().startOf('M')}
                    dependencies={['mode', 'to_date']}
                    rules={[
                      {
                        required: false,
                        message: <IntlMessage id="global.requiredfeild" />,
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (getFieldValue('mode')) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error('Please select mode!!'),
                          );
                        },
                      }),
                    ]}>
                    <DatePicker
                      placeholder={
                        mode === 'month'
                          ? 'Mois'
                          : mode === 'date'
                            ? 'Date'
                            : 'Jour'
                      }
                      format={mode === 'month' ? 'MM-YYYY' : 'DD-MM-YYYY'}
                      picker={mode}
                    />
                  </Form.Item>
                </Col>
                {mode === 'date' && (
                  <Col>
                    <Form.Item
                      name="to_date"
                      // initialValue={dayjs().endOf('M')}
                      dependencies={['mode', 'from_date']}
                      rules={[
                        {
                          required: false,
                          message: <IntlMessage id="global.requiredfeild" />,
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              (value && getFieldValue('from_date')) ||
                              !getFieldValue('from_date')
                            ) {
                              return Promise.resolve();
                            }

                            return Promise.reject(
                              new Error('Please select from date!!'),
                            );
                          },
                        }),
                      ]}>
                      <DatePicker
                        placeholder="Date"
                        format={'DD-MM-YYYY'}
                        picker={mode}
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Filtrer
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        <Row gutter={[16, 16]} wrap>
          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col
                xs={{ span: 12 }}
                sm={{ span: 12 }}
                md={{ span: 6 }}
                lg={{ span: 6 }}>
                <Card
                  bordered
                  style={
                    type === chartSalesType.TOTAL
                      ? {
                          backgroundColor: '#15bc8c0f',
                          boxShadow: '#15bc8c 0px 0px 5px',
                          border: '1px solid #15bc8c',
                          height: '100%',
                        }
                      : {
                          height: '100%',
                        }
                  }
                  hoverable={true}
                  onClick={() => onChangeType(chartSalesType.TOTAL)}>
                  <Spin spinning={loading}>
                    <Space
                      direction="vertical"
                      size={2}
                      style={{ width: '100%', textAlign: 'center' }}>
                      <Text>
                        <IntlMessage id="global.total" />
                      </Text>
                      <Text>
                        # {formatNumber(total.pass_cashier + total.pass_yobuma)}
                      </Text>
                      <Text strong>
                        <Text>
                          {formatCurrency(total?.cashier + total.yobuma)}
                        </Text>
                      </Text>
                    </Space>
                  </Spin>
                </Card>
              </Col>
              <Col
                xs={{ span: 12 }}
                sm={{ span: 12 }}
                md={{ span: 6 }}
                lg={{ span: 6 }}>
                <Card
                  bordered
                  style={
                    type === chartSalesType.YOBUMA
                      ? {
                          backgroundColor: '#15bc8c0f',
                          boxShadow: '#15bc8c 0px 0px 5px',
                          border: '1px solid #15bc8c',
                          height: '100%',
                        }
                      : {
                          height: '100%',
                        }
                  }
                  hoverable={true}
                  onClick={() => onChangeType(chartSalesType.YOBUMA)}>
                  <Spin spinning={loading}>
                    <Space
                      direction="vertical"
                      size={2}
                      style={{ width: '100%', textAlign: 'center' }}>
                      <Text>
                        <IntlMessage id="global.yobuma" />
                      </Text>
                      <Text># {formatNumber(total.pass_yobuma)}</Text>
                      <Text strong>
                        <Text>{formatCurrency(total.yobuma)}</Text>
                      </Text>
                    </Space>
                  </Spin>
                </Card>
              </Col>
              <Col
                xs={{ span: 12 }}
                sm={{ span: 12 }}
                md={{ span: 6 }}
                lg={{ span: 6 }}>
                <Card
                  bordered
                  style={
                    type === chartSalesType.CASHIER
                      ? {
                          backgroundColor: '#15bc8c0f',
                          boxShadow: '#15bc8c 0px 0px 5px',
                          border: '1px solid #15bc8c',
                          height: '100%',
                        }
                      : {
                          height: '100%',
                        }
                  }
                  hoverable={true}
                  onClick={() => onChangeType(chartSalesType.CASHIER)}>
                  <Spin spinning={loading}>
                    <Space
                      direction="vertical"
                      size={2}
                      style={{ width: '100%', textAlign: 'center' }}>
                      <Text>
                        <IntlMessage id="global.cashier" />
                      </Text>

                      <Text># {formatNumber(total.pass_cashier)}</Text>
                      <Text strong style={fs_16}>
                        <Text>{formatCurrency(total.cashier)}</Text>
                      </Text>
                    </Space>
                  </Spin>
                </Card>
              </Col>
              <Col
                xs={{ span: 12 }}
                sm={{ span: 12 }}
                md={{ span: 6 }}
                lg={{ span: 6 }}>
                <Card
                  bordered
                  style={{
                    height: '100%',
                  }}>
                  <Spin spinning={loading}>
                    <Space
                      direction="vertical"
                      size={2}
                      style={{ width: '100%', textAlign: 'center' }}>
                      <Text>
                        <IntlMessage id="global.filling_rate" />
                      </Text>
                      <Text>
                        {total?.filling_rate
                          ? `${total?.filling_rate.toFixed(2)} %`
                          : '0 %'}
                      </Text>
                    </Space>
                  </Spin>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col span={24} style={{ textAlign: 'center' }}>
            {loading ? (
              <Spin spinning={loading}></Spin>
            ) : (
              <div style={{ height: '400px' }}>
                <Line {...option} />
              </div>
            )}
          </Col>
        </Row>

        <br />
        {form.getFieldValue('to') && form.getFieldValue('from') && !loading && (
          <Table
            dataSource={dataTable_first}
            columns={columns}
            tableLayout="auto"
            loading={loading}
            bordered
            scroll={{ x: 'max-content' }}
            rowKey="id"
            size="small"
          />
        )}
      </>
    </Space>
  );
};

Statistics.propTypes = {};

export default Statistics;
